import { NgModule } from "@angular/core";
import { EffectsModule } from "@ngrx/effects";
import { StoreModule } from "@ngrx/store";
import { StoreDevtoolsModule } from "@ngrx/store-devtools";
import { ReporteStoreModule } from "src/app/mapa/store/reporte-store.module";
import { MaquinasStoreModule } from "src/app/maquinas/store/maquina-store.module";
import { LocalidadStoreModule } from "src/app/usuarios/store/localidad/localidad-store.module";
import { environment } from "src/environments/environment";
import { actionReducer, metaReducers } from ".";



@NgModule({
    declarations: [],
    exports: [],
    imports: [
        MaquinasStoreModule,
        LocalidadStoreModule,
        ReporteStoreModule,
        StoreModule.forRoot(actionReducer, { metaReducers: metaReducers }),
        EffectsModule.forRoot([]),
        StoreDevtoolsModule.instrument({
            name: "telemetria",
            maxAge: 25,
            logOnly: environment.production,
        }),
    ]
})
export class AppStoreModule {}
